import React, { memo, useEffect, useMemo, useState } from 'react';
import Tippy from '@tippyjs/react';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { OrderType } from 'models/order.model';

type Props = { order: OrderType };

const formatElapsed = (ms: number) => {
  const mins = Math.floor(ms / 60000);

  if (mins <= 0) return 'Just now';
  if (mins === 1) return '1 min';
  return `${mins} mins`;
};

const UnpaidOrderTimer = ({ order }: Props) => {
  const createdAtMs = useMemo(() => {
    if (!order.created_at) return null;
    const ts = new Date(order.created_at).getTime();
    return Number.isNaN(ts) ? null : ts;
  }, [order.created_at]);

  const [displayTime, setDisplayTime] = useState('Just now');

  useEffect(() => {
    if (!createdAtMs) return;

    const tick = () => {
      setDisplayTime(formatElapsed(Date.now() - createdAtMs));
    };

    tick();
    const id = window.setInterval(tick, 30_000);

    return () => window.clearInterval(id);
  }, [createdAtMs]);

  if (!createdAtMs) return null;

  return (
    <Tippy
      content={
        <div className='p-2 px-3 rounded-md shadow-md bg-white text-gray-8 font-medium text-xs'>
          This order has been unpaid over{' '}
          <span className='font-bold text-[#D58300]'>{displayTime}</span>, and requires review.
        </div>
      }>
      <div className='flex items-center rounded-[40px] gap-1 bg-[#D5830017] border border-[#D58300B2] px-2 py-1'>
        <ClockIcon className='w-4 h-4 text-[#D58300]' />
        <p className='text-xs font-medium text-[#D58300]'>{displayTime}</p>
      </div>
    </Tippy>
  );
};

export default memo(UnpaidOrderTimer);
